<script lang="ts">
  import type { ClickEvent } from '#app/types/declarations/svelte'
  import type { SerializedEntity } from '#entities/lib/entities'
  import { I18n } from '#user/lib/i18n'

  const {
    entities,
    entityTypeLabel,
    pluralizedEntityTypeLabel,
    loadInternalLinkAndClose,
  }: {
    entities: SerializedEntity[]
    entityTypeLabel: string
    pluralizedEntityTypeLabel: string
    loadInternalLinkAndClose: (event: ClickEvent) => void
  } = $props()
</script>

{#if entities.length >= 1}
  <span class="section-label">
    {#if entities.length > 1}{I18n(pluralizedEntityTypeLabel)}{:else}{I18n(entityTypeLabel)}{/if}
  </span>
  {#each entities as entity (entity.uri)}
    <a class="related-entity" href={entity.pathname} onclick={loadInternalLinkAndClose}>
      <span class="related-entity-label" lang={entity.labelLang}>{entity.label}</span>
    </a>
  {/each}
{/if}

<style lang="scss">
  @import "general/scss/utils";
  .related-entity-label{
    font-weight: bold;
  }
  .related-entity{
    @include display-flex(column, center, center);
    text-align: center;
    min-height: 3em;
    margin: 0.2em 0;
    @include bg-hover-svelte(#f3f3f3);
  }
</style>
